<script setup>
import WorksheetKanbanBoard from '@/components/garage/WorksheetKanbanBoard.vue'
</script>
<template>
  <worksheet-kanban-board />
</template>
